const state = {
  switch:false,
  items:[],
  ismouseopen:'已关闭'
};

const mutations = {

};

const actions = {

};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};




// WEBPACK FOOTER //
// ./src/store/mouseBaiduRank.js